"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFormattedPrimitiveAttrJSONSchema = void 0;
const getFormattedPrimitiveAttrJSONSchema = (attr) => {
    if (attr.type === 'binary') {
        return { type: 'string' };
    }
    return { type: attr.type };
};
exports.getFormattedPrimitiveAttrJSONSchema = getFormattedPrimitiveAttrJSONSchema;
